<template>
  <li class="notifications-list-item">
    <div @click="openItem()" class="list-item-content" :class="['list-item-content--' + item.status]">
      <div v-if="notificationContent" class="item-content">
        <div class="item-status" />
        <div class="item-description">
          <div class="item-description--title">{{ itemTitle }}</div>
          <div class="item-description--date"><time :datetime="item.event_time">{{ itemDate }}</time></div>
        </div>
        <div class="item-icon">
          <div class="item-icon--gekkoavatar">
            <svg width="92" height="114" viewBox="0 0 92 114" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M40.66 51.7C46.07 51.7 52.9 51.88 61.57 51.88C72.47 51.88 81.57 43.55 81.57 34.29C81.53 27.71 80 20.2 66.7 16.2C59.14 13.93 51.53 11.55 40.7 12.56C39.3939 12.3858 38.0777 12.299 36.76 12.3C20.24 12.3 0 27.71 0 58.92C0 58.92 0 52.14 0 65.92C0 79.7 0.55 85 2.6 91.39C7.39 106.44 20.24 114 36.79 114C53.34 114 66.06 105.65 70.71 90.75C72.35 85.69 73.03 79.75 73.03 71.56V63.86C73.0401 63.6774 73.0116 63.4948 72.9464 63.324C72.8811 63.1532 72.7805 62.9981 72.6512 62.8688C72.5219 62.7395 72.3668 62.6389 72.196 62.5736C72.0252 62.5084 71.8426 62.4799 71.66 62.49H35.16C34.9779 62.4797 34.7956 62.5082 34.6253 62.5736C34.4549 62.6389 34.3004 62.7397 34.1719 62.8691C34.0434 62.9986 33.9438 63.1539 33.8797 63.3247C33.8155 63.4955 33.7884 63.6779 33.8 63.86V77C33.7882 77.1816 33.8154 77.3637 33.8796 77.534C33.9437 77.7044 34.0435 77.8591 34.1722 77.9878C34.3009 78.1165 34.4556 78.2163 34.626 78.2804C34.7963 78.3446 34.9784 78.3718 35.16 78.36H52.25C52.3621 78.3448 52.4763 78.3559 52.5834 78.3925C52.6905 78.429 52.7876 78.4899 52.8671 78.5704C52.9467 78.6509 53.0064 78.7487 53.0416 78.8563C53.0768 78.9638 53.0865 79.0781 53.07 79.19C53.1829 81.7053 52.8199 84.2194 52 86.6C50.09 92.76 44.07 96.18 37.1 96.18C29.03 96.18 23.97 92.35 21.91 85.92C21.17 83.68 20.74 80.86 20.54 75.42V75.59C20.54 73.89 20.54 72.31 20.59 70.85C20.59 70.49 20.59 70.16 20.59 69.85C20.89 65.84 23 51.76 40.66 51.7Z" fill="white" />
              <path d="M57.4799 15.15C57.4838 17.4866 56.7945 19.772 55.4992 21.7167C54.2039 23.6615 52.3609 25.1783 50.2032 26.0753C48.0456 26.9722 45.6704 27.2089 43.3781 26.7555C41.0859 26.3021 38.9797 25.1789 37.326 23.528C35.6724 21.8772 34.5456 19.7728 34.0883 17.4814C33.6309 15.1899 33.8637 12.8143 34.7569 10.6551C35.6502 8.49598 37.1639 6.65033 39.1065 5.35175C41.0491 4.05316 43.3332 3.36001 45.6699 3.36C47.2194 3.35869 48.7541 3.66261 50.1863 4.2544C51.6184 4.84619 52.92 5.71427 54.0166 6.80907C55.1133 7.90388 55.9836 9.20396 56.5778 10.6351C57.172 12.0662 57.4785 13.6004 57.4799 15.15Z" fill="white" />
              <path d="M88.6298 15.15C88.6318 17.4842 87.9414 19.7666 86.646 21.7085C85.3506 23.6503 83.5084 25.1643 81.3524 26.0589C79.1964 26.9536 76.8235 27.1887 74.5339 26.7345C72.2442 26.2803 70.1407 25.1573 68.4895 23.5074C66.8382 21.8575 65.7134 19.755 65.2573 17.4657C64.8011 15.1765 65.0342 12.8034 65.9271 10.6466C66.8199 8.4899 68.3323 6.6464 70.273 5.34936C72.2137 4.05231 74.4955 3.36 76.8298 3.36C79.9576 3.36 82.9575 4.60184 85.1701 6.8126C87.3828 9.02337 88.6271 12.0222 88.6298 15.15V15.15Z" fill="white" />
              <path d="M80.6702 15.15C80.6741 15.9127 80.4514 16.6594 80.0304 17.2954C79.6093 17.9314 79.0088 18.4279 78.3051 18.7221C77.6014 19.0163 76.8261 19.0948 76.0777 18.9477C75.3293 18.8006 74.6414 18.4345 74.1014 17.8959C73.5614 17.3573 73.1935 16.6704 73.0444 15.9223C72.8954 15.1743 72.9719 14.3989 73.2642 13.6944C73.5566 12.9899 74.0516 12.3881 74.6864 11.9654C75.3213 11.5426 76.0674 11.318 76.8302 11.32C77.8469 11.32 78.8221 11.7232 79.5419 12.4412C80.2618 13.1591 80.6675 14.1333 80.6702 15.15V15.15Z" fill="#231F20" />
              <path d="M49.5198 15.15C49.5237 15.9123 49.3013 16.6586 48.8807 17.2944C48.46 17.9301 47.8602 18.4267 47.157 18.7212C46.4539 19.0156 45.6792 19.0947 44.931 18.9484C44.1829 18.8021 43.495 18.4371 42.9546 17.8994C42.4141 17.3618 42.0455 16.6758 41.8953 15.9285C41.7451 15.1811 41.8202 14.406 42.111 13.7013C42.4018 12.9967 42.8952 12.3942 43.5288 11.9702C44.1623 11.5463 44.9075 11.32 45.6698 11.32C46.174 11.3187 46.6736 11.4167 47.14 11.6085C47.6064 11.8002 48.0305 12.082 48.388 12.4376C48.7455 12.7933 49.0295 13.2159 49.2236 13.6812C49.4178 14.1466 49.5185 14.6457 49.5198 15.15Z" fill="#231F20" />
              <path d="M76.8299 1C73.6532 1.00296 70.5696 2.07327 68.0742 4.0391C65.5788 6.00494 63.8164 8.75227 63.0699 11.84H59.4399C58.6207 8.41433 56.5558 5.41617 53.6474 3.42934C50.739 1.44251 47.1952 0.609233 43.7061 1.09178C40.2171 1.57432 37.0325 3.33814 34.7725 6.03977C32.5125 8.74141 31.3389 12.1875 31.4802 15.7069C31.6215 19.2263 33.0675 22.5672 35.5368 25.079C38.0061 27.5907 41.3219 29.0936 44.8384 29.2949C48.3549 29.4962 51.8204 28.3815 54.5602 26.1679C57.3 23.9544 59.1179 20.8003 59.6599 17.32H62.8499C63.2631 19.9972 64.4356 22.4997 66.2283 24.5306C68.0209 26.5615 70.3585 28.0356 72.9638 28.7779C75.569 29.5203 78.3325 29.4998 80.9264 28.7188C83.5203 27.9379 85.8357 26.4292 87.598 24.3719C89.3603 22.3147 90.4956 19.795 90.869 17.112C91.2424 14.4289 90.8384 11.695 89.7048 9.23471C88.5713 6.77437 86.7558 4.69081 84.4737 3.23122C82.1916 1.77163 79.5388 0.997271 76.8299 1V1ZM45.6699 24.59C43.8057 24.588 41.9838 24.0335 40.4346 22.9966C38.8854 21.9597 37.6783 20.4868 36.9658 18.7641C36.2533 17.0414 36.0674 15.1462 36.4316 13.3179C36.7958 11.4895 37.6937 9.8102 39.0119 8.49199C40.3301 7.17379 42.0094 6.27587 43.8377 5.91169C45.666 5.54751 47.5613 5.73342 49.284 6.44591C51.0067 7.15841 52.4795 8.36552 53.5165 9.91474C54.5534 11.464 55.1079 13.2858 55.1099 15.15C55.1046 17.652 54.1083 20.0501 52.3391 21.8193C50.5699 23.5885 48.1719 24.5847 45.6699 24.59V24.59ZM76.8299 24.59C74.9657 24.588 73.1438 24.0335 71.5946 22.9966C70.0454 21.9597 68.8383 20.4868 68.1258 18.7641C67.4133 17.0414 67.2274 15.1462 67.5916 13.3179C67.9557 11.4895 68.8537 9.8102 70.1719 8.49199C71.4901 7.17379 73.1694 6.27587 74.9977 5.91169C76.826 5.54751 78.7213 5.73342 80.444 6.44591C82.1667 7.15841 83.6395 8.36552 84.6765 9.91474C85.7134 11.464 86.2679 13.2858 86.2699 15.15C86.2672 17.6528 85.2718 20.0524 83.502 21.8222C81.7323 23.5919 79.3327 24.5874 76.8299 24.59V24.59Z" fill="#231F20" />
              <path d="M60.8499 46C58.0691 45.9999 55.3349 45.2853 52.9096 43.9247C50.4844 42.5641 48.4494 40.6032 46.9999 38.23C46.769 37.7059 46.7358 37.1159 46.9063 36.5692C47.0768 36.0224 47.4395 35.5559 47.9273 35.2559C48.4151 34.9559 48.9951 34.8427 49.5599 34.9372C50.1248 35.0317 50.6363 35.3275 50.9999 35.77C52.0302 37.4386 53.4701 38.816 55.1827 39.7714C56.8953 40.7267 58.8238 41.2282 60.7849 41.2282C62.746 41.2282 64.6744 40.7267 66.3871 39.7714C68.0997 38.816 69.5396 37.4386 70.5699 35.77C70.7107 35.4693 70.9135 35.2017 71.1649 34.9847C71.4162 34.7676 71.7105 34.6061 72.0286 34.5107C72.3467 34.4152 72.6813 34.3879 73.0106 34.4306C73.3399 34.4734 73.6565 34.5851 73.9397 34.7585C74.2229 34.932 74.4663 35.1632 74.654 35.4372C74.8417 35.7112 74.9694 36.0216 75.0289 36.3483C75.0884 36.6751 75.0782 37.0106 74.9991 37.3332C74.92 37.6557 74.7738 37.9579 74.5699 38.22C73.1693 40.5488 71.2007 42.4842 68.8484 43.8449C66.4961 45.2055 63.8369 45.9471 61.1199 46H60.8499Z" fill="#231F20" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from 'moment';
export default {
  props: {
    item: {
      type: Object,
      default: () => {} 
    }
  },
  data () {
    return {
      notificationContent: null
    }
  },
  computed: {
    itemTitle () {
      return this.item.grammar.replace('%object_name', this.item.object_name)
    },
    itemDate () {
      return moment(new Date(this.item.event_time)).format('MMM DD YYYY')  + ' at ' + moment(new Date(this.item.event_time)).format('hh:ssa')
    },
    ...mapGetters({ 
      getGekkoNotification: "notifications/getGekkoNotification"
    }),
  },
  mounted () {
    this.notificationContent = true
  },
  methods: {
    ...mapActions({ 
      loadNotificationTemplate: "notifications/loadNotificationTemplate",
      toggleStatus: "notifications/toggleNotificationStatus",
      openModal: "dashboard/openModal",
    }),
    getNotificationContent () {
      this.notificationContent = this.getGekkoNotification(this.item.gekko_notification)
      if (!this.notificationContent) {
        // console.log('loading notification via api')
        this.loadNotificationTemplate(this.item.gekko_notification).then((response) => {
          this.notificationContent = response
          // console.log('notification loaded', this.notificationContent)
        })
      }
    },
    openItem () {
      if(this.item.status === 'unseen') {
        this.toggleStatus(this.item.id)
        this.item.status = 'seen'
      }
      this.openModal(this.item)
    }
  }
}
</script>

<style lang="scss">
  li.notifications-list-item {
    position: relative;
    margin-bottom: 11px;
    &:after {
      content: '';
      position: absolute;
      bottom: -6px;
      left: 0px;
      width: 100%;
      height: 1px;
      background: $colorBorderDash;
    }
    &:hover {
      .list-item-content {
        background: #f6f6f6;
        text-decoration: none;
        opacity: 1;
      }
    }
    .list-item-content {
      display: flex;
      flex-direction: column;
      cursor: pointer;
      transition: all 0.1s ease; 
      padding: 7px;
      background: white;
      border-radius: 8px;
      .item-content {
        display :flex;
        align-items: center;
      }
      .item-status {
        width: 10px;
        height: 10px;
        border-radius: 100%;
        background: white;
      }

      &--seen {
        .item-status {
          background: $colorBorderDash;
        }
      }
      &--unseen,
      &--pending {
        .item-status {
          background: $colorBrand;
        }
      }

      .item-description {
        min-width: 0;
        display: flex;
        justify-content: space-between;
        flex: 1;
        font-size: 14px;
        color: $colorTextBase;
        line-height: 1.3;
        flex-direction: column;
        margin-left: 7px;
        &--title {
          font-family: DINNextLTPro-Medium, sans-serif;
          margin-bottom: 5px;
          font-size: 15px;
          line-height: 1.2;
        }
        &--text {
          color: #8d939d;
          margin-bottom: 7px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;  
          line-height: 1.2;
        }
        &--date {
          color: #8d939d;
          font-size: 12px;
          opacity: 0.7;
        }
      }
      .item-icon {
        position: relative;
        &--gekkoavatar {
          height: 45px;
          width: 45px;
          border-radius: 100%;
          margin-left: 7px;
          display: flex;
          justify-content: center;
          align-items: center;
          
          svg {
            display: block;
            width: 30px;
            height: 30px;
          }
          background: $colorBrand;
          color: white;
        }
      }
    }
  }
</style>